

import * as actionTypes from './actionTypes';
import * as actions from './index';

export const updateFaceObjectsSuccess = (data) => {
    return {
        type: actionTypes.FACE_UPDATE_FACEOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateFaceObjects = (obj) => {
    return (dispatch) => {
        dispatch(updateFaceObjectsSuccess(obj));
    }
}

export const getFaceData = ({ clip }) => {
    let aidata = null;
    try {
        aidata = JSON.parse(clip.getMetadata().get('compreface'));
    } catch (e) {
        console.log("LOGS: getFaceData ERROR", e);
    }
    return aidata;
}

export const getObjectData = ({ clip }) => {
    let aidata = {};
    let resObj;

    if (clip && clip.id == 787) {
        resObj = {
            "detections": [
                {
                    "label": "car",
                    "confidence": 0.9485538601875305,
                    "x_min": 168.6709747314453,
                    "y_min": 200.60768127441406,
                    "x_max": 420.5064392089844,
                    "y_max": 319.4270935058594
                },
                {
                    "label": "bench",
                    "confidence": 0.06712976843118668,
                    "x_min": 471.8264465332031,
                    "y_min": 199.64004516601562,
                    "x_max": 496.2322082519531,
                    "y_max": 208.59161376953125
                }
            ]
        };
    }

    if (resObj && resObj.detections && resObj.detections.length) {
        if (aidata && aidata.cfrecognize) {
            aidata.cfrecognize = resObj.detections.map(item => {
                return {
                    box: {
                        probability: item.confidence,
                        "x_min": item.x_min, "y_min": item.y_min,
                        "x_max": item.x_max, "y_max": item.y_max
                    },
                    subjects: [
                        { subject: item.label, similarity: item.confidence }
                    ]
                }
            })
        }

    }

    return aidata;
}

export const getClipAiData = ({ clipId, isObject, isFace }) => {
    return async (dispatch) => {
        const clip = await window.flow.getClipById(clipId);

        let aidata;
        if (isFace) aidata = getFaceData({ clip });
        if (isObject) aidata = getObjectData({ clip });

        let clipUrl, clipWidth = 750, clipHeight = 420;
        if (clip && clip.data && clip.data.mainthumbnail
            && clip.data.mainthumbnail.data && clip.data.mainthumbnail.data.url) {
            clipUrl = clip.data.mainthumbnail.data.url;
            if (clipUrl) {
                clipUrl += `&width=${clipWidth}&height=${clipHeight}&ext=.JPG`;
                if (!clipUrl.includes("https:")) {
                    clipUrl = "https:" + clipUrl;
                }
            }
            if (aidata && aidata.cfrecognize) {
                dispatch(actions.updateFaceObjects({
                    faceRecognize: {
                        data: aidata.cfrecognize, clipId: clip.id, clipUrl,
                        clipHeight, clipWidth, showOverlay: true
                    }
                }));
            }
        }
    }
}

export const recognizeFace = ({ clipId }) => {
    return async (dispatch) => {
        try {
            const res = await window.flow.comprefaceRecognize(clipId);
            console.log("LOGS: recognizeFace", res);
            if (res.result) {
                dispatch(getClipAiData({ clipId, isFace: true }));
            }
        } catch (err) {
            console.log("LOGS: DETECT OBJECT");
            //Detect Objects 
            dispatch(getClipAiData({ clipId, isObject: true }));
        }
    }
}

export const getSubjects = (res) => {
    let subjects = [];
    if (res && res.value && res.value.subjects) {
        subjects = res.value.subjects
            .map((item, index) => ({ subject: item, id: index }));
    }
    return subjects;
}

export const listSubjects = (current = false) => {
    return async (dispatch, getState) => {
        const { faceSubjects } = getState().face.faceObjects;
        const res = await window.flow.comprefaceSubjectList();
        const subjects = getSubjects(res);
        if (subjects) dispatch(updateFaceObjects({
            faceSubjects: { ...faceSubjects, subjects },
            faceCurrent: current
        }));
    }
}

export const renameSubject = ({ from, to, current }) => {
    return async (dispatch, getState) => {
        if (from, to) {
            const res = await window.flow.comprefaceSubjectRename(from, to);
            console.log("LOGS: renameSubject res", res);
            dispatch(listSubjects(current));
        }
    }
}

export const addSubject = ({ name }) => {
    return async (dispatch, getState) => {
        const { faceSubjects } = getState().face.faceObjects;
        if (name) {
            const res = await window.flow.comprefaceSubjectAdd(name);
            const subjects = getSubjects(res);
            if (subjects) dispatch(updateFaceObjects({ faceSubjects: { ...faceSubjects, subjects } }));
        }
    }
}

export const deleteSubject = ({ name }) => {
    return async (dispatch) => {
        if (name) {
            const res = await window.flow.comprefaceSubjectDelete(name);
            console.log("LOGS: deleteSubject res", res);
            dispatch(listSubjects());
        }
    }
}

export const listCollections = () => {
    return async (dispatch, getState) => {
        const { faceCollections } = getState().face.faceObjects;
        const res = await window.flow.comprefaceFacecollectionList();
        console.log("LOGS: listCollections res", res);
        if (res && res.faces) {
            dispatch(updateFaceObjects({ faceCollections: { ...faceCollections, faces: res.faces } }));
        }
    }
}

export const faceUploadStart = (obj) => {
    return {
        type: actionTypes.FACE_UPLOAD_START,
        payload: obj
    }
}

export const addImgToSubject = ({ image, subject, current }) => {
    return async (dispatch, getState) => {
        if (subject) {
            let upRes = await window.flow.uploadFile(image).promise;
            console.log("LOGS: LAMTEST addImgToSubject upRes", upRes);
            let fn;
            if (upRes && upRes.localfile) {
                fn = upRes.localfile;
                try {
                    let res = await window.flow.comprefaceFacecollectionAdd(fn, subject);
                    console.log("LOGS: LAMTEST addImgToSubject", res);
                } catch (e) {
                    console.log("LOGS: LAMTEST addImgToSubject e", e);
                }
                dispatch(listSubjects(current));
            }
        }
    }
}

export const deleteImgFromCollection = ({ imageId, subject }) => {
    return async (dispatch) => {
        if (imageId) {
            const res = await window.flow.comprefaceFacecollectionDelete(imageId);
            if (res && res.image_id == imageId) {
                console.log("LOGS: Delete Image", res);
                dispatch(listSubjects(subject));
                dispatch(listCollections());
            }
        }
    }
}


